// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1s5i8","head":"Table_head__3pgCn","col":"Table_col__3kiP-"};